import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../LoadingSpinner';
import SecondarySupervisorReviewForm from './SecondarySupervisorReviewForm';
import PrimarySupervisorReviewForm from './PrimarySupervisorReviewForm';
import { Alert } from 'react-bootstrap';
import { ReviewerRole, ReviewStatus } from '../../../graphql/__generated__/graphql';
import useApplicationReview from './hooks/useApplicationReview';

const ApplicationReviewForm: React.FC = () => {
    const { applicationReviewId } = useParams<{ applicationReviewId: string }>();

    const {
        models: { applicationReview, loading, updating },
        operations: { update },
    } = useApplicationReview(applicationReviewId!);

    if (!applicationReview) return <LoadingSpinner />;

    const formParams = {
        applicationReview,
        readOnly:
            applicationReview.reviewStatus === ReviewStatus.Complete ||
            applicationReview.reviewStatus === ReviewStatus.WaitingOnApplicant,
        loading,
        handleUpdate: update,
        updating,
    };

    switch (applicationReview.reviewerRole) {
        case ReviewerRole.PrimarySupervisor:
            return <PrimarySupervisorReviewForm {...formParams} />;
        case ReviewerRole.SecondarySupervisor:
            return <SecondarySupervisorReviewForm {...formParams} />;
        default:
            return <Alert variant={'danger'}>Something went wrong</Alert>;
    }
};

export default ApplicationReviewForm;
